import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  List,
  ListItem,
  Link,
  Paper,
  Button,
  IconButton,
  TextField,
  Select,
  MenuItem,
  Grid
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import logo0 from '../assets/logo0.png';
import larrvariesLogo from '../assets/logo0.png';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const FAQ2 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

  return (
    <Box sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ 
        bgcolor: '#000000', 
        color: 'white',
        py: 1
      }}>
        <Container maxWidth="xl">
          {/* Top Navigation */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 1
          }}>
            {/* Logo */}
            <img 
              src={logo0} 
              alt="Larrvaries" 
              style={{ 
                height: '30px',
                filter: 'brightness(0) invert(1)',
                objectFit: 'contain'
              }} 
            />

            {/* Right Navigation */}
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center',
              gap: 2
            }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                {['Solutions', 'Pricing', 'AI', 'Questions', 'AIChat', 'Options'].map((item) => (
                  <Typography
                    key={item}
                    sx={{
                      color: '#fff',
                      fontSize: '14px',
                      cursor: 'pointer',
                      '&:hover': { color: '#ccc' }
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
              
              <TextField
                size="small"
                placeholder="Suchen"
                sx={{
                  width: '200px',
                  backgroundColor: '#333',
                  '& .MuiOutlinedInput-root': {
                    color: 'white',
                    '& fieldset': {
                      borderColor: 'transparent',
                    }
                  },
                  '& .MuiInputBase-input': {
                    color: 'white',
                  }
                }}
              />
              
              <Button
                sx={{
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: 0,
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.1)'
                  }
                }}
              >
                Login
              </Button>
              
              <Button
                sx={{
                  bgcolor: '#00873C',
                  color: '#fff',
                  textTransform: 'none',
                  borderRadius: 0,
                  '&:hover': {
                    bgcolor: '#006c30'
                  }
                }}
              >
                Join now
              </Button>
            </Box>
          </Box>

          {/* Search Bar */}
          <Box sx={{ 
            display: 'flex', 
            gap: 1,
            alignItems: 'center'
          }}>
            <TextField
              fullWidth
              placeholder="Find your desired domain with AI search"
              size="small"
              sx={{
                bgcolor: '#fff',
                '& .MuiOutlinedInput-root': {
                  borderRadius: 0,
                  '& fieldset': {
                    borderColor: 'transparent',
                  }
                }
              }}
            />
            <Button
              sx={{
                bgcolor: '#333',
                color: '#fff',
                textTransform: 'none',
                borderRadius: 0,
                '&:hover': {
                  bgcolor: '#444'
                }
              }}
            >
              Scan
            </Button>
            <Select
              value="de"
              size="small"
              sx={{
                bgcolor: '#fff',
                width: '70px',
                borderRadius: 0,
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'transparent'
                }
              }}
            >
              <MenuItem value="de">de</MenuItem>
            </Select>
            <Select
              value="com"
              size="small"
              sx={{
                bgcolor: '#fff',
                width: '70px',
                borderRadius: 0,
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'transparent'
                }
              }}
            >
              <MenuItem value="com">com</MenuItem>
            </Select>
            <Typography sx={{ color: '#fff', fontSize: '14px', whiteSpace: 'nowrap' }}>
              0,08 €* / pro Monat im 1. Jahr
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* Content Area */}
      <Container maxWidth="xl" sx={{ pt: 4 }}>
        <Box sx={{ 
          display: 'flex', 
          gap: 4,
          flexDirection: { xs: 'column', md: 'row' }
        }}>
          {/* Sidebar */}
          <Box sx={{ 
            width: { xs: '100%', md: '260px' },
            flexShrink: 0
          }}>
            <Typography sx={{ 
              color: '#545B64', 
              fontSize: '12px',
              fontWeight: 'bold',
              mb: 2 
            }}>
              PRODUITS ET SERVICES
            </Typography>
            <List sx={{ p: 0 }}>
              <ListItem sx={{ p: 0, mb: 1 }}>
                <Link
                  component={RouterLink}
                  to="#"
                  sx={{
                    color: '#E47911',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' }
                  }}
                >
                  FAQ Larrvaries
                </Link>
              </ListItem>
            </List>

            <Typography sx={{ 
              color: '#545B64', 
              fontSize: '12px',
              fontWeight: 'bold',
              mt: 3,
              mb: 2 
            }}>
              LIENS CONNEXES
            </Typography>
            <List sx={{ p: 0 }}>
              {[
                'Larrvaries Support',
                'Forums de discussion',
                'Tableau de bord de l\'état des services',
                'Contactez-nous',
                'Centre de support',
                'Produits et services Larrvaries'
              ].map((item) => (
                <ListItem key={item} sx={{ p: 0, mb: 1 }}>
                  <Link
                    component={RouterLink}
                    to="#"
                    sx={{
                      color: '#0972d3',
                      textDecoration: 'none',
                      '&:hover': { textDecoration: 'underline' }
                    }}
                  >
                    {item}
                  </Link>
                </ListItem>
              ))}
            </List>
          </Box>

          {/* Main Content */}
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4" sx={{ mb: 2, color: '#000' }}>
              Your top questions answered
            </Typography>

            <Typography variant="h5" sx={{ mb: 3, color: '#000' }}>
              Frequently asked questions
            </Typography>

            <Typography sx={{ mb: 4, color: '#000' }}>
              Select from the list of services and technical FAQs below. Browse these FAQs to find answers to commonly asked questions. If you're new to any of the services listed below, we recommend reading all articles related to that service.
            </Typography>

            <Grid container spacing={4}>
              {/* Common Questions */}
              <Grid item xs={12}>
                <List sx={{ p: 0 }}>
                  {[
                    'We already use GitHub Copilot. How is this different?',
                    'We already have too many tools. Why do we need this?',
                    'We already use ChatGPT. How is this different?',
                    'How is this different from Enterprise Search tools?',
                    'This looks like just another thing I would need to manage.'
                  ].map((item) => (
                    <ListItem 
                      key={item} 
                      sx={{ 
                        p: 2, 
                        mb: 1,
                        border: '1px solid #eee',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        '&:hover': {
                          bgcolor: '#f8f9fa'
                        }
                      }}
                    >
                      <Typography sx={{ color: '#000' }}>
                        {item}
                      </Typography>
                      <Box sx={{ 
                        color: '#0972d3',
                        display: 'flex',
                        alignItems: 'center'
                      }}>
                        ▼
                      </Box>
                    </ListItem>
                  ))}
                </List>
              </Grid>

              {/* AI Services Column */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ mb: 2, color: '#000' }}>
                  AI Services
                </Typography>
                <List sx={{ p: 0 }}>
                  {[
                    'FAQ on Larrvaries AI Chat',
                    'FAQ on Larrvaries AI Search',
                    'FAQ on Larrvaries AI Domain Finder'
                  ].map((item) => (
                    <ListItem key={item} sx={{ p: 0, mb: 1 }}>
                      <Link
                        component={RouterLink}
                        to="#"
                        sx={{
                          color: '#0972d3',
                          textDecoration: 'none',
                          '&:hover': { textDecoration: 'underline' }
                        }}
                      >
                        {item}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </Grid>

              {/* Domain Services Column */}
              <Grid item xs={12} md={6}>
                <Typography variant="h6" sx={{ mb: 2, color: '#000' }}>
                  Domain Services
                </Typography>
                <List sx={{ p: 0 }}>
                  {[
                    'FAQ on Larrvaries Domain Registration',
                    'FAQ on Larrvaries Domain Transfer',
                    'FAQ on Larrvaries Domain Management'
                  ].map((item) => (
                    <ListItem key={item} sx={{ p: 0, mb: 1 }}>
                      <Link
                        component={RouterLink}
                        to="#"
                        sx={{
                          color: '#0972d3',
                          textDecoration: 'none',
                          '&:hover': { textDecoration: 'underline' }
                        }}
                      >
                        {item}
                      </Link>
                    </ListItem>
                  ))}
                </List>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default FAQ2;